import * as HiIcons from "react-icons/hi";
import * as RiIcons from "react-icons/ri";
import * as FaIcons from "react-icons/fa";
import * as IoIcons from "react-icons/io";
import * as AiIcons from "react-icons/ai";
import * as TbIcons from "react-icons/tb";
import * as PiIcons from "react-icons/pi";

export const iconMap = {
  ...HiIcons,
  ...RiIcons,
  ...FaIcons,
  ...IoIcons,
  ...AiIcons,
  ...TbIcons,
  ...PiIcons,
};
//NCR1 URL: https://transglobeedu.com/web-backend
// export const API_URL = "http://65.21.151.100:3002/web-backend";
export const API_URL = "https://dash.transglobeedu.com/web-backend";

//VPS URL for later to be added
//export const API_URL = "vps_URL" || "https://transglobeedu.com/web-backend";

//Local
export const L_API_URL = "";
//export const L_API_URL = "https://issuing-compound-rebate.ngrok-free.dev";
// export const L_API_URL = "http://localhost:5005";
